import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DriveFile } from '../services/myDriveService';

interface Props {
  open: boolean;
  file: DriveFile | null;
  onConfirm: (newName: string) => void;
  onClose: () => void;
}

export default function RenameDialog({ open, file, onConfirm, onClose }: Props) {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  useEffect(() => { if (file) setName(file.filename); }, [file]);

  const handleConfirm = () => {
    const trimmed = name.trim();
    if (trimmed && trimmed !== file?.filename) onConfirm(trimmed);
    else onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('myDrive.rename', '重新命名')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus fullWidth size="small" sx={{ mt: 1 }}
          label={t('myDrive.renamePlaceholder', '新名稱')}
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleConfirm()}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel', '取消')}</Button>
        <Button variant="contained" onClick={handleConfirm} disabled={!name.trim()}>
          {t('common.confirm', '確認')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
